import { gql } from '@apollo/client'

import { DISH_LIST_FRAGMENT } from '../fragments'

const UPDATE_DISH_WITH_MANUAL_AND_AI_SUGGESTIONS_MUTATION = gql`
  mutation updateDishWithManualAndAiSuggestions(
    $id: ID!
    $data: DishManualAndAiSuggestionInput!
  ) {
    updateDishWithManualAndAiSuggestions(id: $id, data: $data) {
      ...DishListFragment
    }
  }
  ${DISH_LIST_FRAGMENT}
`

export default UPDATE_DISH_WITH_MANUAL_AND_AI_SUGGESTIONS_MUTATION
